export default __webpack_public_path__ + "static/media/End_Program_Modal.7b935aa9.png";